//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbEyewearProtectionModal from '@/elements/cart/eyewear-protection/rb-eyewear-protection-modal.vue'
import RbEyewearProtectionPanel from '@/elements/cart/eyewear-protection/rb-eyewear-protection-panel.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'

export default {
  name: 'rb-eyewear-protection-panel-and-modal',

  components: {
    RbEyewearProtectionModal,
    RbEyewearProtectionPanel,
  },

  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isVisible(nValue) {
      document.querySelector('html').style.overflow = nValue ? 'hidden' : ''
    },
  },
  computed: {
    isMobileOrTablet() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
  },

  methods: {
    closeOverlay() {
      this.$emit('closeOverlay')
    },
  },
}
